





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Assets from '@/constants/assets';

import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

export enum FieldSetColor {
  Primary = 'field-set--primary',
  Gold = 'field-set--gold',
}

@Component({
  components: {
    Icon,
  },
})
export default class FieldSet extends Vue {
  @Prop({ default: '' }) private title!: string;
  @Prop({ default: false }) private collapsable!: boolean;
  @Prop({ default: false }) private squad!: boolean;
  @Prop({ default: false }) private collapsed!: boolean;
  @Prop({ default: '' }) private subtitle!: string;
  @Prop({ default: FieldSetColor.Primary })
  private fieldSetColor!: FieldSetColor;

  private iconEnum = IconEnum;

  get hasTitle() {
    return this.title !== '';
  }

  private hasSlot(slotName: string) {
    return !!this.$slots[slotName];
  }

  private hasSubtitle() {
    return this.subtitle !== '';
  }

  private toggleCollapsed() {
    this.$emit('input', !this.collapsed);
  }
}
